import api from '../api.js';

export const marketStoryRequests = {
  getByPeriod: (startMonth, startYear, endMonth, endYear) => {
    return api.get(
      `/reports/period?startMonth=${startMonth}&startYear=${startYear}&endMonth=${endMonth}&endYear=${endYear}`,
      { cache: 'no-store' },
    );
  },
};

export default marketStoryRequests;
